import { RouteRecordRaw } from 'vue-router';
import { deltaGptRoutes, getResearchRoutes } from '../deltaGptRoutes.ts';
import { CommercialAndIndustrialResearchNames, SectionRouteNames } from './sectionRouteNames.ts';

export const commercialAndIndustrialRoutes: Record<string, RouteRecordRaw> = {
    home: {
        path: '',
        name: `${SectionRouteNames.commercialAndIndustrial}Home`,
        components: {
            default: () => import('@/views/sectionViews/commercialAndIndustrial/CommercialAndIndustrialHomeView.vue'),
        },
        meta: {
            headName: 'Commercial & Industrial Home',
            displayTitle: 'Home',
        },
    },
    distributedPower: {
        path: 'distributed-power/research',
        name: `${CommercialAndIndustrialResearchNames.distributedPower}`,
        redirect: { name: `${CommercialAndIndustrialResearchNames.distributedPower}_${deltaGptRoutes.documentList.name as string}` },
        children: getResearchRoutes(`${CommercialAndIndustrialResearchNames.distributedPower}`),
        meta: {
            headName: 'Distributed Power',
            searchMeta: {
                tags: ['research'],
            },
        },
    },
    digitalSolutions: {
        path: 'digital-solutions/research',
        name: `${CommercialAndIndustrialResearchNames.digitalSolutions}`,
        redirect: { name: `${CommercialAndIndustrialResearchNames.digitalSolutions}_${deltaGptRoutes.documentList.name as string}` },
        children: getResearchRoutes(`${CommercialAndIndustrialResearchNames.digitalSolutions}`),
        meta: {
            headName: 'Digital Solutions',
            searchMeta: {
                tags: ['research'],
            },
        },
    },
    strategy: {
        path: 'strategy/research',
        name: `${CommercialAndIndustrialResearchNames.strategy}`,
        redirect: { name: `${CommercialAndIndustrialResearchNames.strategy}_${deltaGptRoutes.documentList.name as string}` },
        children: getResearchRoutes(`${CommercialAndIndustrialResearchNames.strategy}`),
        meta: {
            headName: 'Strategy',
            searchMeta: {
                tags: ['research'],
            },
        },
    },
    solarAndBattery: {
        path: 'solar-and-battery/research',
        name: `${CommercialAndIndustrialResearchNames.solarAndBattery}`,
        redirect: { name: `${CommercialAndIndustrialResearchNames.solarAndBattery}_${deltaGptRoutes.documentList.name as string}` },
        children: getResearchRoutes(`${CommercialAndIndustrialResearchNames.solarAndBattery}`),
        meta: {
            headName: 'Solar & Battery',
            searchMeta: {
                tags: ['research'],
            },
        },
    },
    research: {
        path: 'all/research',
        name: `${CommercialAndIndustrialResearchNames.commercialAndIndustrialAll}`,
        redirect: { name: `${CommercialAndIndustrialResearchNames.commercialAndIndustrialAll}_${deltaGptRoutes.documentList.name as string}` },
        children: getResearchRoutes(`${CommercialAndIndustrialResearchNames.commercialAndIndustrialAll}`),
        meta: {
            headName: 'All',
            searchMeta: {
                tags: ['research'],
            },
        },
    },
};
